import * as angular from "angular";

export
    function CustomerController(dataHub, $q, $window, $stateParams: any) {
        var vm = this;
        vm.model = null;
        const hub = dataHub();
        vm.hub = hub;
        hub.onConnected(() => {
            init();
        });

        function init() {
            var companyGuid = $stateParams.companyGuid,
                customerGuid = $stateParams.customerGuid,
                add = $stateParams.add,
                name = $stateParams.name;
            if (!companyGuid) alert('error');
            vm.company = { guid: companyGuid };
            hub.company.load(companyGuid).then(() => {
                vm.company = hub.company.list[0]; // wishful thinking
                console.log(vm.company);
                hub.customer.search('', vm.company.customer.guid, 999).then(() => {
                    if (add) {
                        vm.create(name);
                    } else if (customerGuid) {
                        vm.model = hub.customer.searchResults.filter(i => i.guid === customerGuid)[0];
                    }

                });
            });
        }

        vm.create = function (name) {
            vm.model = {
                company: vm.company,
                name: name
            };
        };

        vm.edit = function (entity) {
            vm.model = angular.copy(entity);
        };

        vm.save = function (close) {
            hub.invoke('customerSubSave', vm.model)
                .then(() => {
                    vm.model = null;
                    if (close) $window.close();
                });
        };

        vm.clear = function() {
            vm.model = null;
        }


    }
